export const FileTypes = {
  pdf: 'application/pdf',
};
